export const futureTasksRoutesName = {
    futureTasks: "future-tasks",
};
